import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import NoFeedbackSubOptions from '../../../components/troubleShooting/articleDetails/NoFeedbackSubOptions';


const NoFeedbackOptionComponent = (props) => {
  const feedbackNoOptionData = props.NofeedbackOptionsData.feedbackNoOptions;
  function getObjKey(obj, optionid, value) {

    let optionArray = feedbackNoOptionData.filter(obj => {
      return obj.optionId === optionid
    })

      
    const opArray = optionArray[0];
    return opArray.children;
  }

    return (
      <Modal className="noFeebackOptionModal" show={props.isOpen}>
          <form method='post' onSubmit={props.saveNoFeedback}>
          <Modal.Header>
            <Modal.Title>申し訳ございません。<br/>今後の改善のため、解決できなかった理由をお選びください。<br/><span>※送信後、お問い合わせ方法をご案内いたします
</span></Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div className='noFeebackOption'>

          {feedbackNoOptionData.map((option) => (

          (option.hasOwnProperty('children')) ? 
       
          <span key={option.optionId}>
            <div   data-value={option.optionId} onClick={props.getchildren}>{option.optionName}
            {(props.haschildren === 1) ?
            <span className='noFeedback_arrow' data-value={option.optionId}>&#9650;</span>
              : <span className='noFeedback_arrow' data-value={option.optionId}>&#9660;</span> }
            </div>
             { 
             
             (props.haschildren === 1) ? 
             
             <NoFeedbackSubOptions  handleInputChange={props.handleInputChange} childrenArry={getObjKey(feedbackNoOptionData, option.optionId, 'children')} />
             
             
             :''}

          </span>
           : <div className={(props.haschildren === 1) ? 'showHide' : ''} key={option.optionId}><label><input type="radio" onChange={props.handleInputChange} className='option-input' name="noFeedbackOptionID" id="noFeedbackOptionID" value={option.optionId} />{option.optionName}</label></div>
            
            

         ))}


          </div>
          </Modal.Body>
          <Modal.Footer>
           <Button  type="submit" disabled={(props.noFeedbackOptionSelected === 0) ? true  : false}>送信</Button>
          </Modal.Footer>
          </form>
        </Modal>
    );
  }

  
export default NoFeedbackOptionComponent;